import { IIconProps } from "@/models";
import { SvgIcon } from "@mui/material";

const DiagonalArrowIcon = ({ sx, className, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 8 8"
      sx={{ fontSize: "inherit", fill: "none", ...sx }}
      {...otherProps}
    >
      <path
        d="M0.534176 7.75178C0.398399 7.75178 0.262622 7.70176 0.155429 7.59456C-0.0518098 7.38732 -0.0518098 7.04431 0.155429 6.83707L6.01529 0.977207C6.22253 0.769968 6.56555 0.769968 6.77279 0.977207C6.98002 1.18445 6.98002 1.52746 6.77279 1.7347L0.912923 7.59456C0.805731 7.70176 0.669954 7.75178 0.534176 7.75178Z"
        fill="currentColor"
      />
      <path
        d="M6.96608 4.77182C6.67309 4.77182 6.43012 4.52885 6.43012 4.23586V1.32022H3.51448C3.22149 1.32022 2.97852 1.07725 2.97852 0.784254C2.97852 0.491261 3.22149 0.248291 3.51448 0.248291H6.96608C7.25907 0.248291 7.50204 0.491261 7.50204 0.784254V4.23586C7.50204 4.52885 7.25907 4.77182 6.96608 4.77182Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default DiagonalArrowIcon;
